export default "__VITE_ASSET__CyeNik4q__"